import { useRequest } from "@prismicio/editor-support/Suspense"

import { useEditorConfig } from "../../../EditorConfig"
import { useMediaLibrary } from "../components/MediaLibraryContext"
import { searchMedia, searchMediaArgs } from "./mediaLibraryData"

/**
 * Queries the first page of the current repos media library
 * The first page will have an accurate total of the full media library, without
 * search keywords or filters
 *
 * @returns total {number}
 */
export function useMediaLibraryFirstPageTotal() {
  const config = useEditorConfig()
  const { initialAssetType } = useMediaLibrary()

  const {
    assetsApiBaseUrl = undefined,
    repository = "",
    authStrategy = "token",
  } = config.mediaLibrary ? config : {}

  const { total } = useRequest(
    searchMedia,
    searchMediaArgs({
      assetsApiBaseUrl,
      authStrategy,
      repository,
      assetType: initialAssetType,
      keyword: "",
      tagIds: [],
      page: 0,
    }),
  )

  return total
}
